{
  "business-real-estate": "Business Real Estate",
  "investment-real-estate": "Investment Real Estate",
  "land": "Land",
  "primary-residence": "Primary Residence",
  "second-home": "Second Home",
  "timeshare": "Timeshare",
  "default": "Real Estate"
}
